import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';

const Logout = ({ onLogout }) => {
  useEffect(() => {
    if (onLogout) {
      onLogout();
    }
  }, [onLogout]);

  return <Fragment />;
};

Logout.propTypes = {
  onLogout: PropTypes.func,
};

export default Logout;



// WEBPACK FOOTER //
// ./src/containers/Login/Logout.js